import React from 'react';
import { isMobile } from 'react-device-detect';
import MusicAlbumEditForm2ListItemView from './MusicAlbumEditForm2ListItemView';
import { MusicAlbumTrackEntity } from '../../types/MusicAlbumEntityTypes';
import { MusicEntity } from '../../types/MusicEntityTypes';

/**
 * リストにソート機能を付与する
 */
function Sortable({
  onSort,
  children
} : {
  onSort: (ids: string[]) => void,
  children: React.ReactNode,
}) {
  const containerRef = React.useRef(null);

  //  モバイルの時はドラッグ&ドロップによるソート無効
  if (!isMobile) {
    React.useEffect(() => {
      if (containerRef.current === null) return;
      const $sortable = $(containerRef.current);
      $sortable.sortable({
        stop() {
          const ids = $sortable.sortable('toArray');
          $sortable.sortable('cancel');
          onSort(ids);
        },
      });
      return () => {
        if (containerRef.current === null) return;
        $(containerRef.current).sortable('destroy');
      };
    });
  }

  return (
    <div ref={containerRef}>
      {children}
    </div>
  );
}

/**
 * ソート可能なトラック一覧
 *
 * 原則としてステートレスに作られているので、
 * 内容の変更を反映するためには、propsのイベントハンドラを使い、
 * musicAlbumTracksを上位コンポーネントで変更する処理を実装する。
 *
 * @param {object} props プロパティ
 * @returns コンポーネント
 */
export default function MusicAlbumEditForm2ListView({
  musicAlbumTracks,
  onSort,
  onMovePrev,
  onMoveNext,
  onDelete,
} : {
  musicAlbumTracks: (MusicAlbumTrackEntity & {
    music: MusicEntity,
  })[],
  onSort: (ids: string[]) => void,
  onMovePrev: (musicAlbumTrack: MusicAlbumTrackEntity, trackNo: number) => void,
  onMoveNext: (musicAlbumTrack: MusicAlbumTrackEntity, trackNo: number) => void,
  onDelete: (musicAlbumTrack: MusicAlbumTrackEntity) => void,
}) {
  return (
    <>
      <div className="song_list" id="song_list_">
        <Sortable onSort={(ids) => { onSort(ids); }}>
          {musicAlbumTracks.map((musicAlbumTrack, index) => (
            <div id={`${musicAlbumTrack.track_no}`} key={musicAlbumTrack.id}>
              <MusicAlbumEditForm2ListItemView
                isLastTrack={index === musicAlbumTracks.length - 1}
                musicAlbumTrack={musicAlbumTrack}
                //trackNo={index + 1}
                onDelete={() => { onDelete(musicAlbumTrack); }}
                onMovePrev={() => { onMovePrev(musicAlbumTrack, index + 1); }}
                onMoveNext={() => { onMoveNext(musicAlbumTrack, index + 1); }}
              />
            </div>
          ))}
        </Sortable>
      </div>
    </>
  );
}
